import { Observable } from 'rxjs';

export enum VoucherTab {
    general = 'general',
    situationDP = 'situationDP',
    situationORP = 'situationORP',
    situationFT = 'situationFT',
    prescriptions = 'prescriptions',
}

export interface VoucherTabs {
    Id: VoucherTab;
    Label: string;
    isInvalid$?: Observable<boolean>;
}

export interface SituationFTSketchMarkingPoint {
    x: number;
    y: number;
}

export interface VoucherSequenceInfo {
    sequenceNumber: number | null;
    lastVoucherId: number | null;
}
